/*
* Dinamic fee because the price changes globally
* Transfer amount does not affect it
*/
export default [
  'eth',
  'bnb',
  'matic',
  'arbeth',
  'aureth',
  'phi_v1',
  'phi',
  'xdai',
  'ftm',
  'avax',
  'movr',
  'one',
  'ame',
  'btc',
  'ghost',
  'next',
  'fkw',
  'phpx',
]